module.exports = require("@makemydeal/dr-common-utils");